<template>
    <div>

        <div class="container">
            <div class="brand my-5 mx-auto" style="width: 150px !important; height: 50px !important;">
                <img src="~@/assets/logo.png" border="0" style="width: 100%;" />
            </div>

            <div class="row justify-content-center align-items-center">
                <div class="col col-lg-5 col-md-6">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h4 class="card-title mb-3 text-center">Choose your avatar</h4>
                            <div class="mb-2">
                                <label class="form-label">Nickname</label>
                                <input type="text" class="form-control" id="nicknameField" v-model.trim="nickname">
                                <small class="form-text text-danger" v-if="error_nickname">Nickname already in use!</small>
                            </div>
                            <div class="mb-2">
                                <label class="form-label">Gender</label>
                                <div class="d-flex justify-content-around align-items-center border rounded bg-white py-2">
                                    <div class="custom-control custom-radio custom-control">
                                        <input type="radio" id="genderRadio1" class="custom-control-input" value="Uomo" v-model="gender">
                                        <label class="custom-control-label" for="genderRadio1">Male</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control">
                                        <input type="radio" id="genderRadio2" class="custom-control-input" value="Donna" v-model="gender">
                                        <label class="custom-control-label" for="genderRadio2">Female</label>
                                    </div>
                                </div>
                                <small class="form-text text-danger" v-if="error_gender">Gender is required</small>
                            </div>
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-primary" v-if="true" @click="onSaveNickname($event)" :disabled="!isValidNickname">Save Avatar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-secondary my-3 text-center">
                &copy; {{ new Date().getFullYear() }} - V-EXPO
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'SignInNickname',
        data: function () {
            return {
                nickname: null,
                gender: null,
                error_nickname: false,
                error_gender: false
            };
        },
        computed: {
            title() {
                return process.env.VUE_APP_EXHIBITION_NAME || 'VexpoSite';
            },
            currentUserNickname() {
                return this.$store.state.nickname;
            },
            isValidNickname() {
                return this.nickname && this.nickname.length > 3;
            }
        },
        methods: {
            async onSaveNickname(e) {
                try {
                    this.$store.dispatch('setLoading', true);

                    if (!this.gender) {
                        this.error_gender = true;
                        this.$store.dispatch('setLoading', false);
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                    this.error_gender = false;
                    this.error_nickname = false;
                    
                    let url = new URL(process.env.VUE_APP_CHECK_NICKNAME)
                    url.searchParams.append('Nickname', this.nickname);

                    await this.$http.get(url)
                        .then(async () => {
                            // save current nickname + redirect
                            let data = { "Nickname": this.nickname, "Gender": this.gender };
                            await this.$http.post(process.env.VUE_APP_SAVE_NICKNAME, data)
                                .then(() => {
                                    this.$store.dispatch('setNickname', this.nickname);

                                    let param = this.$store.getters.initialQuery;
                                    this.$router.push({ name: 'Home', params: param });
                                });
                        })
                        .catch(error => {
                            // nickname used or error
                            if (error.response.status === 409) {
                                this.error_nickname = true;
                            }
                        })
                }
                catch (e) {
                    this.$store.dispatch('setErrorNotification', 'onSaveNickname error. ' + e);
                }
                finally {
                    this.$store.dispatch('setLoading', false);
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .signin {
        position: absolute;
        top: 0;
        bottom: 0;
    }

    .center-column {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .logo {
        width: 100%;
        max-width: 300px;
        max-height: 300px;
        display: block;
    }
</style>
